import { useEffect, useRef } from "react";
import {
  sendPicture,
  sendMoveSticker,
  sendRotateSticker,
  sendScaleSticker,
  sendRandomValuesSticker,
  sendValidateSticker,
  setupClient,
  PayloadTypes
} from "./utils/NetworkingStickers.js";

import "./style/animations.css";
import "./style/style.css";

function App() {
  const elementsRef = useRef({
    canvas: null,
    ctx: null,
    buttonUploadPicture: null,
    img: null,
    previewSticker: null,
    buttonOK: null,
    pages: [],
    buttonBack: null,
    buttonBackBack: null,
    buttonValidate: null,
    buttonLeft: null,
    buttonRight: null,
    buttonUp: null,
    buttonDown: null,
    buttonRotCW: null,
    buttonRotACW: null,
    buttonScaleUp: null,
    buttonScaleDown: null,
    buttonRandomValues: null,
    previewAndShinyHolder: null,
    shiny: null
  });

  const valuesRef = useRef({
    finalSticker: "",
    drawing: false,
    points: [],
    finalSizeSticker: 512,
    currentPage: 0
  });

  const elems = elementsRef.current;
  const values = valuesRef.current;

  useEffect(() => {
    // Production URL
    var serverAddress = `wss://${window.location.hostname}`;

    // Local Testing URL
    // var serverAddress = "ws://192.168.1.236:3001";

    // Hardcoded testing URl
    // var serverAddress = "wss://stickers.badabeam.com"

    elems.canvas = document.getElementById("canvas");
    elems.previewSticker = document.getElementById("previewSticker");
    elems.ctx = elems.canvas.getContext("2d");
    elems.buttonUploadPicture = document.getElementById("uploadButton");
    elems.buttonSendSticker = document.getElementById("buttonSend");
    elems.buttonOK = document.getElementById("buttonOK");
    elems.buttonBack = document.getElementById("buttonBack");
    elems.buttonBackBack = document.getElementById("buttonBackBack");
    elems.buttonValidate = document.getElementById("buttonValidate");
    elems.previewAndShinyHolder = document.getElementById("previewAndShinyHolder");
    elems.shiny = document.getElementById("shiny");

    elems.buttonLeft = document.getElementById("buttonLeft");
    elems.buttonRight = document.getElementById("buttonRight");
    elems.buttonUp = document.getElementById("buttonUp");
    elems.buttonDown = document.getElementById("buttonDown");
    elems.buttonRotCW = document.getElementById("buttonRotCW");
    elems.buttonRotACW = document.getElementById("buttonRotACW");
    elems.buttonScaleUp = document.getElementById("buttonScaleUp");
    elems.buttonScaleDown = document.getElementById("buttonScaleDown");
    elems.buttonRandomValues = document.getElementById("buttonRandomValues");

    for (let i = 0; i < 4; i++) elems.pages[i] = document.getElementById("page" + i);

    window.onload = function () {
      window.addEventListener("resize", ResizeCanvas);
      elems.buttonUploadPicture.addEventListener("change", LoadImage, false);
      elems.buttonOK.addEventListener("click", GoPreviewSticker, false);
      elems.buttonBack.addEventListener("click", GoBack, false);
      elems.buttonBackBack.addEventListener("click", GoBack, false);
      elems.buttonValidate.addEventListener("click", GoStickSticker, false);

      elems.buttonLeft.addEventListener("click", OnPressButtonLeft, false);
      elems.buttonRight.addEventListener("click", OnPressButtonRight, false);
      elems.buttonUp.addEventListener("click", OnPressButtonUp, false);
      elems.buttonDown.addEventListener("click", OnPressButtonDown, false);
      elems.buttonRotCW.addEventListener("click", OnPressButtonRotCW, false);
      elems.buttonRotACW.addEventListener("click", OnPressButtonRotACW, false);
      elems.buttonScaleUp.addEventListener("click", OnPressButtonScaleUp, false);
      elems.buttonScaleDown.addEventListener("click", OnPressButtonScaleDown, false);
      elems.buttonRandomValues.addEventListener("click", OnPressButtonRandomValues, false);

      elems.canvas.addEventListener("mousedown", OnPressDown);
      elems.canvas.addEventListener("touchstart", OnPressDown);
      elems.canvas.addEventListener("mousemove", OnMove);
      elems.canvas.addEventListener("touchmove", OnMove);
      document.addEventListener("mouseup", OnPressUp);
      document.addEventListener("touchend", OnPressUp);

      ResetValues();
      GoToPage(0);
    };

    function ResetValues() {
      values.finalSticker = "";
      values.drawing = false;
      values.points = [];
    }

    function OnPressDown(e) {
      if (values.currentPage !== 1) return;

      values.drawing = true;
      values.points = [];
      values.points[0] = getCoords(e);
      DrawCanvas(false, true);
    }

    function OnMove(e) {
      if (values.currentPage !== 1) return;
      if (!values.drawing) return;

      values.points.push(getCoords(e));
      DrawCanvas(true, true);
    }

    function OnPressUp() {
      if (values.currentPage !== 1) return;
      if (values.points.length < 3) return;

      values.drawing = false;
      DrawCanvas(true, true);
    }

    function getCoords(event) {
      if (event.offsetX !== undefined) return { x: event.offsetX, y: event.offsetY };
      else if (event.touches) {
        const rect = event.target.getBoundingClientRect();
        const touch = event.touches[0];
        return { x: clamp(touch.clientX - rect.left, 0, elems.canvas.width), y: clamp(touch.clientY - rect.top, 0, elems.canvas.height) };
      }
    }

    function DrawCanvas(drawMask = false, drawStroke = false) {
      elems.ctx.clearRect(0, 0, elems.canvas.width, elems.canvas.height);

      if (drawMask) {
        elems.ctx.globalAlpha = 0.5;
        elems.ctx.drawImage(elems.img, 0, 0, elems.canvas.width, elems.canvas.height);
        elems.ctx.globalAlpha = 1.0;
        elems.ctx.save();
        elems.ctx.beginPath();
        elems.ctx.moveTo(values.points[0].x, values.points[0].y);
        values.points.forEach((p) => elems.ctx.lineTo(p.x, p.y));
        elems.ctx.closePath();
        elems.ctx.clip();
      }

      elems.ctx.drawImage(elems.img, 0, 0, elems.canvas.width, elems.canvas.height);

      if (drawMask) elems.ctx.restore();

      if (drawStroke) {
        elems.ctx.strokeStyle = "white";
        elems.ctx.lineWidth = 2;
        elems.ctx.beginPath();
        elems.ctx.moveTo(values.points[0].x, values.points[0].y);
        values.points.forEach((p) => elems.ctx.lineTo(p.x, p.y));

        if (!values.drawing) elems.ctx.lineTo(values.points[0].x, values.points[0].y);

        elems.ctx.stroke();
      }
    }

    const LoadImage = (event) => {
      if (event.target.files.length === 0) return;
      let file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        elems.img = document.createElement("img");
        elems.img.src = e.target.result;

        elems.img.onload = function (event) {
          ResizeCanvas();
          values.points = [];
          values.points[0] = { x: 0, y: 0 };
          values.points[1] = { x: elems.canvas.width, y: 0 };
          values.points[2] = { x: elems.canvas.width, y: elems.canvas.height };
          values.points[3] = { x: 0, y: elems.canvas.height };
          GoToPage(1);
          DrawCanvas(true, true);
          elems.buttonUploadPicture.value = "";
        };
      };
    };

    function ResizeCanvas() {
      if (elems.img === null) return;

      let imgRatio = elems.img.width / elems.img.height;
      let mult = 0.8;
      let maxWidth = Math.min(window.innerWidth * mult, elems.img.width);
      let maxHeight = Math.min(window.innerHeight * mult, elems.img.height);

      if (maxWidth / maxHeight > imgRatio) {
        elems.canvas.width = maxHeight * imgRatio;
        elems.canvas.height = maxHeight;
      } else {
        elems.canvas.width = maxWidth;
        elems.canvas.height = maxWidth / imgRatio;
      }

      DrawCanvas(false, false);
    }

    function GoToPage(index) {
      values.currentPage = index;

      for (let i = 0; i < 4; i++) {
        elems.pages[i].style.opacity = i === values.currentPage ? "100%" : "0%";
        elems.pages[i].style.pointerEvents = i === values.currentPage ? "auto" : "none";
      }
    }

    function GoBack() {
      if (values.currentPage === 1) {
        GoToPage(0);
        ResetValues();
      } else if (values.currentPage === 2) {
        GoToPage(1);
        DrawCanvas(true, true);
      }
    }

    function GoStickSticker() {
      sendValidateSticker(true);
      GoToPage(3);
      setTimeout(function () {
        GoToPage(0);
        ResetValues();
      }, 3000);
    }

    function GoPreviewSticker() {
      if (values.points.length < 3) {
        values.points = [];
        values.points[0] = { x: 0, y: 0 };
        values.points[1] = { x: elems.canvas.width, y: 0 };
        values.points[2] = { x: elems.canvas.width, y: elems.canvas.height };
        values.points[3] = { x: 0, y: elems.canvas.height };
      }

      let remappedPoints = [];

      for (let i = 0; i < values.points.length; i++) {
        remappedPoints[i] = { x: values.points[i].x, y: values.points[i].y };
        remappedPoints[i].x *= elems.img.width / elems.canvas.width;
        remappedPoints[i].y *= elems.img.height / elems.canvas.height;
      }

      let fullSizeCanvas = document.createElement("canvas");
      fullSizeCanvas.width = elems.img.width;
      fullSizeCanvas.height = elems.img.height;

      let fullSizeCanvasContext = fullSizeCanvas.getContext("2d");
      fullSizeCanvasContext.clearRect(0, 0, fullSizeCanvas.width, fullSizeCanvas.height);
      fullSizeCanvasContext.save();
      fullSizeCanvasContext.beginPath();
      fullSizeCanvasContext.moveTo(remappedPoints[0].x, remappedPoints[0].y);
      remappedPoints.forEach((p) => fullSizeCanvasContext.lineTo(p.x, p.y));
      fullSizeCanvasContext.closePath();
      fullSizeCanvasContext.clip();
      fullSizeCanvasContext.drawImage(elems.img, 0, 0, fullSizeCanvas.width, fullSizeCanvas.height);
      fullSizeCanvasContext.restore();

      let minX = 9999;
      let maxX = -9999;
      let minY = 9999;
      let maxY = -9999;

      for (let i = 0; i < remappedPoints.length; i++) {
        if (remappedPoints[i].x < minX) minX = remappedPoints[i].x;
        if (remappedPoints[i].x > maxX) maxX = remappedPoints[i].x;
        if (remappedPoints[i].y < minY) minY = remappedPoints[i].y;
        if (remappedPoints[i].y > maxY) maxY = remappedPoints[i].y;
      }

      let previewWidth = maxX - minX;
      let previewHeight = maxY - minY;

      let maxLength = Math.max(previewWidth, previewHeight);

      let left = minX - (maxLength - previewWidth) / 2;
      let top = minY - (maxLength - previewHeight) / 2;

      let offscreenCanvas = document.createElement("canvas");
      offscreenCanvas.width = values.finalSizeSticker;
      offscreenCanvas.height = values.finalSizeSticker;
      let offscreenCtx = offscreenCanvas.getContext("2d");

      offscreenCtx.drawImage(fullSizeCanvas, left, top, maxLength, maxLength, 0, 0, values.finalSizeSticker, values.finalSizeSticker);

      values.finalSticker = offscreenCanvas.toDataURL("image/png");

      elems.previewSticker.src = values.finalSticker;

      elems.shiny.style.webkitMaskImage = `url(${values.finalSticker})`;
      elems.shiny.style.maskImage = `url(${values.finalSticker})`;
      elems.shiny.style.webkitMaskSize = "cover";
      elems.shiny.style.maskSize = "cover";
      GoToPage(2);
      GoSendData(null);
      AnimateDiv("popup");
    }

    function OnPressButtonLeft() {
      sendMoveSticker([1.0, 0.0]);
      AnimateDiv("moveLeft");
    }

    function OnPressButtonRight() {
      sendMoveSticker([-1.0, 0.0]);
      AnimateDiv("moveRight");
    }

    function OnPressButtonUp() {
      sendMoveSticker([0.0, 1.0]);
      AnimateDiv("moveUp");
    }

    function OnPressButtonDown() {
      sendMoveSticker([0.0, -1.0]);
      AnimateDiv("moveDown");
    }

    function OnPressButtonRotCW() {
      sendRotateSticker(true);
      AnimateDiv("rotateRight");
    }

    function OnPressButtonRotACW() {
      sendRotateSticker(false);
      AnimateDiv("rotateLeft");
    }

    function OnPressButtonScaleUp() {
      sendScaleSticker(true);
      AnimateDiv("grow");
    }

    function OnPressButtonScaleDown() {
      sendScaleSticker(false);
      AnimateDiv("shrink");
    }

    function OnPressButtonRandomValues() {
      sendRandomValuesSticker(true);
      AnimateDiv("shake");
    }

    function AnimateDiv(animationName) {
      elems.previewAndShinyHolder.classList.remove("animate");

      elems.previewAndShinyHolder.style.animationName = "none";
      void elems.previewAndShinyHolder.offsetWidth; // Trick to restart animation
      elems.previewAndShinyHolder.style.animationName = animationName;
      elems.previewAndShinyHolder.classList.add("animate");
    }

    function GoSendData(event) {
      let toSend = values.finalSticker.split("base64,")[1];
      sendData(toSend);
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(value, max));
    }

    const sendData = (d) => {
      sendPicture({
        id: "client_message",
        payloadType: PayloadTypes.String,
        payload: d
      });
    };

    setupClient(serverAddress);
  }, [elems, values]);

  return (
    <div id="container">
      <div id="toast-container"></div>
      <div id="page0" className="page" style={{ opacity: "100%", pointerEvents: "auto" }}>
        <img id="upload-text-img" src="/stickers/upload_text.png" alt="upload icon in the shape of a camera" />
        {/* <div className="titlePage"></div> */}
        <div id="uploadButtonHolder">
          <input accept="image/*" id="uploadButton" type="file" style={{ display: "none" }} />
          <label htmlFor="uploadButton" id="cameraIcon"></label>
        </div>
      </div>
      <div id="page1" className="page">
        <div className="headerGroup">
          <img src="/stickers/draw_sticker_shape.png" className="stickers-shape-text" alt="Text saying: Draw Your Sticker Shape" />
          <nav className="page1-nav">
            <button className="navig" id="buttonBack">
              <img src="/stickers/back_button.png" alt="back" />
            </button>
            <button className="navig" id="buttonOK">
              <img src="/stickers/ok_button_green.png" alt="ok" />
            </button>
          </nav>
        </div>
        <canvas id="canvas"></canvas>
      </div>
      <div id="page2" className="page">
        <div id="previewStickerHolder">
          <div id="previewAndShinyHolder">
            <img id="previewSticker" alt="previewSticker" />
            <div id="shiny">
              <div id="shiny-inner"></div>
            </div>
          </div>
          <svg width="0" height="0">
            <defs>
              <filter id="outline-filter" x="-50%" y="-50%" width="200%" height="200%">
                <feMorphology operator="dilate" radius="5" in="SourceAlpha" result="outline" />
                <feFlood floodColor="white" result="whiteColor" />
                <feComposite in="whiteColor" in2="outline" operator="in" result="stroke" />
                <feMerge>
                  <feMergeNode in="stroke" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
          </svg>
        </div>

        <div id="buttonsControlStickerHolder">
          <div id="gridContainer">
            <div className="gridCell" id="buttonLeft">
              <button className="buttonControlSticker">
                <img src="/stickers/arrow.png" alt="random" />
              </button>
            </div>
            <div className="gridCell" id="buttonRight">
              <button className="buttonControlSticker">
                <img src="/stickers/arrow.png" alt="random" />
              </button>
            </div>
            <div className="gridCell" id="buttonUp">
              <button className="buttonControlSticker">
                <img src="/stickers/arrow.png" alt="random" />
              </button>
            </div>
            <div className="gridCell" id="buttonDown">
              <button className="buttonControlSticker">
                <img src="/stickers/arrow.png" alt="random" />
              </button>
            </div>
            <div className="gridCell" id="buttonRotCW">
              <button className="buttonControlSticker2">
                <img src="/stickers/rotate_cw.png" alt="random" />
              </button>
            </div>
            <div className="gridCell" id="buttonRotACW">
              <button className="buttonControlSticker2">
                <img src="/stickers/rotate.png" alt="random" />
              </button>
            </div>
            <div className="gridCell" id="buttonScaleUp">
              <button className="buttonControlSticker2">
                <img src="/stickers/plus.png" alt="random" />
              </button>
            </div>
            <div className="gridCell" id="buttonScaleDown">
              <button className="buttonControlSticker2">
                <img src="/stickers/minus.png" alt="random" />
              </button>
            </div>
            <div className="gridCell" id="buttonRandomValues">
              <button className="buttonControlSticker2">
                <img src="/stickers/random.png" alt="random" />
              </button>
            </div>
          </div>
        </div>

        <img id="placeSticker" src="/stickers/position_text.png" alt="Place your sticker" />
        <button className="navig" id="buttonBackBack">
          <img src="/stickers/back_button.png" alt="back" />
        </button>
        <button className="navig" id="buttonValidate">
          <img src="/stickers/ok_button_green.png" alt="ok" />
        </button>
      </div>
      <div id="page3" className="page">
        {/* <div id="sticked">STICKED!!!</div> */}
        <img id="sticked" src="/stickers/sticked_text.png" alt="text saying !!!sticked!!!" />
      </div>
    </div>
  );
}

export default App;
